module.exports = __webpack_public_path__ + "img/lecturerTip.b72f50c0.png";